import { Component, OnInit } from '@angular/core';
import { LogoService } from 'src/app/logo.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  year: any = new Date().getFullYear();
  themeName: any = '';
  constructor(private logoService: LogoService) { }

  ngOnInit() {
    this.themeName = this.logoService.themeName;
  }

}
